<div class="modal fade" tabindex="-1" [id]="'regularProgressModal'">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div *ngIf="!error && phasesCompleted!==total || total === 0" class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <i *ngIf="error" class="bi bi-exclamation-triangle-fill fs-1 text-danger"></i>
                <i *ngIf="phasesCompleted===total && total !== 0"
                    class="bi bi-check-circle-fill fs-1 text-success mb-2"></i>
                <h4 class="modal-title fw-bold">loading...</h4>
                <h5 *ngIf="head5" class="modal-title">{{ head5 }}</h5>
            </div>
            <div class="modal-body text-center">
                <div *ngIf="extendedMessage" [innerHTML]="extendedMessage | translate" [class]="innerHTMLStyle"></div>
                <p>{{ '' }}</p>
                <div class="progress-container">
                    <div class="progress-counter">{{phasesCompleted ? phasesCompleted : '1' }} <span> / {{total ? total : '-'}}</span></div>
                    <div *ngIf="!error" class="progress-bar">
                        <div class="progress" [style.background]="total ? 'green' : 'black' " [style.width]="total ? phasesCompleted ? (phasesCompleted!/total!*100)+'%' : '0' : '0'">
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="footer" class="modal-footer">
                <button type="button" class="btn btn-dark" data-bs-dismiss="modal">{{
                    (cancelText ? cancelText : 'LICENSE.CONTINUECREATING') | translate
                    }}</button>
            </div>
        </div>
    </div>
</div>
